/** Shared broadcast audio profile + CDN defaults used by both Dashboard tiles
 *  and the ChannelSettingsDialog. Extracted from Dashboard.jsx for
 *  maintainability. */

export const DEFAULT_AUDIO_PROFILE = {
  sample_rate_hz: 48000,
  bit_depth: 24,
  primary_layout: "5.1",
  channel_map: ["L", "R", "C", "LFE", "Ls", "Rs"],
  delivery_codec: "AC-3",
  delivery_bitrate_kbps: 448,
  loudness_target_lkfs: -24.0,
  loudness_spec: "ATSC A/85",
  loudness_tolerance_lu: 2.0,
  dialnorm: -24,
  true_peak_ceiling_dbtp: -2.0,
  downmix_mode: "LtRt",
  downmix_embed_metadata: true,
  downmix_center_mix_db: -3.0,
  downmix_surround_mix_db: -3.0,
};

export const audioProfileOf = (channel) => ({
  ...DEFAULT_AUDIO_PROFILE,
  ...(channel?.audio_profile || {}),
});

export const DEFAULT_CDN = {
  publish_state: "idle",
  origin_url: "",
  dvr_window_sec: 3600,
  edge_cache_sec: 6,
  hls_segment_sec: 4,
  hls_playlist_type: "LIVE",
};

export const cdnOf = (channel) => ({ ...DEFAULT_CDN, ...(channel?.cdn || {}) });
